import { Helmet } from "react-helmet-async";
import { srcSetFor, bestSrcFor, webpSrc } from "@/lib/webpSrc";

/**
 * Emits `<link rel="preload" as="image">` for the LCP hero image so the
 * browser starts downloading it in parallel with the JS bundle. Uses
 * `imagesrcset` / `imagesizes` so the responsive-picking logic is honoured.
 *
 * Drop this once at the top of a route component:
 *   <HeroPreload src="/assets/karls/hero-architecture.jpg" sizes="100vw" />
 *
 * With imagesrcset + imagesizes the browser picks the *right* size on mobile
 * (e.g. the 480w WebP) — so the preload doesn't waste bandwidth on desktop
 * users' 1440w file being fetched on a 390-px phone.
 */
export default function HeroPreload({ src, sizes = "100vw" }) {
  if (!src) return null;
  const srcSet = srcSetFor(src);
  const fallback = srcSet ? bestSrcFor(src) : webpSrc(src);
  return (
    <Helmet>
      <link
        rel="preload"
        as="image"
        href={fallback}
        {...(srcSet ? { imageSrcSet: srcSet, imageSizes: sizes } : {})}
        fetchPriority="high"
      />
    </Helmet>
  );
}
